import { useState } from "react";
import { Collapsible } from "../../components/Collapsible/Collapsible";
import "./FAQ.css";

const qnas = [
  {
    question:
      "I don't know what's on my tape and no longer have a player, how can I find out what's on there?",
    answer:
      "This is by far the most commonly asked question which is why I offer a FREE tape assessment service. If you send me your tape, whether it's cassette, reel to reel, mini/microcasette or DAT, I will have a listen and tell you what's on it and approximately how much it will cost to transfer. If you decide not to go ahead you just need to pay for return postage or I can get rid of the tape for you.",
  },
  {
    question: "What about copyright?",
    answer:
      "In simple terms, any recording made over 50 years ago is now out of copyright restrictions (nearly all 78s). Any other recording is subject to the laws of copyright. This doesn't mean you can't copy it, it just means you can't abuse the system. There is a phrase which the Americans use: 'fair use'. In essence you can make a copy of your original and use it for your own personal use, i.e. to play it in your car or on your MP3 player. As long as you retain the orignial and don't sell it, or copies made from it, then you are not abusing the copyright system. Of course if you own the copyright, say you have a cassette recording of the band you were in in the 80s, then you can make as many copies you like. These recordings often benefit from equalisation to bring them back to life, removing crowd noise, tape hiss, unwanted thumps and bumps etc. We can also create unique album covers and on-CD printing if you have old photos or posters from gigs where your band played. These often make ideal presents for the once 'Rock God' in your life!",
  },
  {
    question: "How long does it take?",
    answer:
      "This depends on the material and how much cleaning up the recording needs. In most cases we aim to return the original and CD copy within 10 working days. If you need it faster than that we can usually help out.",
  },
  {
    question: "Why don't you reproduce album covers?",
    answer:
      "It is illegal to reproduce original artwork of any kind without written permission from the copyright holder. For example it is OK to transfer the audio from one format to another, but the album artwork is not essential for you to be able to hear the music. At Audio Reunited each cover we do will have a simple text cover with a track list on the rear and album/artist information on the front and spine. Obviously if you own the copyright to the album artwork we are able to use it with your permission.",
  },
  {
    question: "Why can't I do it myself?",
    answer:
      "Well of course you can, if you buy one of the record deck to USB machines out of the newspaper ads then you should do OK. The difference is that we professionally clean each record with a vacuum based machine, this sucks out a great deal of the dust and grime that accumulates on records over the years. The transfer is then much clearer and has fewer clicks and pops, even brand new records benefit from this cleaning process. Once you've done the transfer you always get the clicks and pops associated with playing records, we use sophisticated software to remove almost all of these annoying noises and also any hum which you often get when playing a record. With all our experience and technology available we endeavour to get the best possible transfer of your record.",
  },
  {
    question: "What if you can't do anything with the recording?",
    answer:
      "If, for example, a 78 is damaged to an extent where we can't perform miracles it is usually fairly obvious once we receive it. There are also cases when a tape is blank. In these cases we will not charge you anything apart from return postage.",
  },
];

const answers = [];

export const FAQ = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const changeOpenQuestion = (questionNumber) =>
    setOpenQuestion(questionNumber === openQuestion ? null : questionNumber);

  return (
    <div className="faq-container">
      <h1>Frequently Asked Questions</h1>
      {qnas.map(({ question, answer }, index) => (
        <Collapsible
          open={openQuestion === index}
          onClick={() => changeOpenQuestion(index)}
          buttonText={question}
        >
          {answer}
        </Collapsible>
      ))}
    </div>
  );
};
